import React, { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { toast } from "sonner";

export default function PostComments({ postId }) {
  const [comments, setComments] = useState([]);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/posts/${postId}/comments`)
      .then((r) => setComments(r.data))
      .catch((err) => console.warn("Failed to load comments", err))
      .finally(() => setLoading(false));
  }, [postId]);

  const addComment = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    try {
      const r = await api.post(`/posts/${postId}/comments`, { content: text });
      setComments((prev) => [...prev, r.data]);
      setText("");
      window.dispatchEvent(new CustomEvent("haeven:mission"));
      if (r.data.moderation?.flag) {
        toast.warning("Heads up: " + (r.data.moderation.reason || "Your comment may be hurtful"));
      }
    } catch { toast.error("Could not comment"); }
  };

  return (
    <div className="mt-4 space-y-3 border-t-2 border-foreground pt-4">
      {loading ? <div className="text-sm text-muted-foreground">Loading…</div> : comments.length === 0 ? (
        <div className="text-sm text-muted-foreground">No comments yet — be the first kind voice.</div>
      ) : comments.map((c) => (
        <div key={c.id} className="flex gap-2 items-start" data-testid={`comment-item-${c.id}`}>
          <div className="w-8 h-8 rounded-full border-2 border-foreground bg-sage flex items-center justify-center text-xs font-bold">
            {c.author_avatar ? <img src={fileUrl(c.author_avatar)} className="w-full h-full object-cover rounded-full" alt="" /> : c.author_name?.[0]}
          </div>
          <div className="flex-1 brutal-card bg-secondary p-2 px-3">
            <div className="text-xs font-semibold">{c.author_name} <span className="text-muted-foreground font-normal">@{c.author_username}</span></div>
            <div className="text-sm">{c.content}</div>
          </div>
        </div>
      ))}
      <form onSubmit={addComment} className="flex gap-2">
        <input data-testid={`comment-input-${postId}`} value={text} onChange={(e) => setText(e.target.value)}
          maxLength={1000} placeholder="Add a kind comment…" className="brutal-input flex-1 px-3 py-2 text-sm" />
        <button data-testid={`comment-send-${postId}`} type="submit" className="brutal-btn bg-primary text-primary-foreground px-3 py-2 text-sm">Send</button>
      </form>
    </div>
  );
}